import styled from '@emotion/styled';

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
`;

export const StyledSpinnerWrapper = styled.div`
  width: 100%;
  height: 40rem;
  overflow-y: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
`;

export const StyledTitle = styled.div`
  text-align: center;
  font-family: 'Urbanist';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  margin-bottom: 10px;
`;

export const StyledSubtitle = styled.div`
  text-align: center;
  font-family: 'Urbanist';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  max-width: 30rem;
`;

export const StyledCtContainer = styled.div`
  margin-top: 3rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledBox = styled.div`
  padding: 1.5rem;
  border: 1px solid ${({ theme }) => theme.palette?.grey?.[300]};
  border-radius: 10px;
  margin-top: 2rem;
  max-width: 30rem;
  width: 100%;
  height: 100%;
`;
